import React, { useContext } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { CarouselContext } from './topFiltersCarousel';

export const Title: React.FC = () => {
    const context = useContext(CarouselContext);

    if (!context) {
        return null;
    }

    const { filterId, subCategoryId } = context;

    return (
        <div className="title">
            <h6 className="tbody-3">
                <I18n k={`search_perseus.filter_tiles.${subCategoryId}.${filterId}`} />
            </h6>
        </div>
    );
};
